import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { authGuard } from './core/auth/auth.guard';
import { roleGuard } from './core/auth/role.guard';
import { LoginComponent } from './features/login/login.component';
import { ForbiddenComponent } from './shared/components/forbidden/forbidden.component';
import { NotFoundComponent } from './shared/components/not-found/not-found.component';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'cases' },
  { path: 'login', component: LoginComponent },
  {
    path: 'cases',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./features/case-list/case-list.module').then(m => m.CaseListModule),
  },
  {
    path: 'cases/:caseId',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./features/case-dashboard/case-dashboard.module').then(m => m.CaseDashboardModule),
  },
  {
    path: 'create-case',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./features/create-case/create-case.module').then(m => m.CreateCaseModule),
  },
  {
    path: 'admin',
    canActivate: [authGuard, roleGuard('pdtf-risk:admin')],
    loadChildren: () =>
      import('./features/admin/admin.module').then(m => m.AdminModule),
  },
  {
    path: 'lab',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/document-lab/document-lab.component').then(m => m.DocumentLabComponent),
  },
  { path: 'forbidden', component: ForbiddenComponent },
  { path: '**', component: NotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
